import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// 移除钉钉调试工具
console.error('入口 index.tsx 已加载');

// Polyfill for Object.hasOwn (Safari <16.3)
if (!(Object as any).hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value: function(obj: unknown, prop: PropertyKey) {
      return Object.prototype.hasOwnProperty.call(obj as object, prop);
    },
    configurable: true,
    writable: true
  });
}

// 移除钉钉远程调试初始化

// 全局错误处理
window.addEventListener('error', (event) => {
    console.error('Global error caught:', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error,
        stack: event.error?.stack,
        timestamp: new Date().toISOString()
    });
});

window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', {
        reason: event.reason,
        promise: event.promise,
        timestamp: new Date().toISOString()
    });
});

// 临时屏蔽开发环境下的 webpack-dev-server 客户端 WebSocket (ws://localhost:3001/ws)
// 避免与后端/代理冲突导致的 Invalid frame header 报错
(() => {
  try {
    if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined' && 'WebSocket' in window) {
      const OriginalWS = (window as any).WebSocket;
      class DummyWS {
        public readyState = 3; // CLOSED
        public onopen: any = null;
        public onclose: any = null;
        public onerror: any = null;
        public onmessage: any = null;
        addEventListener() {}
        removeEventListener() {}
        close() {}
        send() {}
      }
      (window as any).WebSocket = new Proxy(OriginalWS, {
        construct(target, args: any[]) {
          const url = String(args?.[0] || '');
          if (url.includes('://localhost:3001/ws')) {
            console.warn('[dev] blocked WDS websocket:', url);
            return new (DummyWS as any)();
          }
          return new (target as any)(...args);
        }
      });
    }
  } catch {}
})();

const rootEl = document.getElementById('root') as HTMLElement;
// Safari iOS 光标/输入焦点兼容：确保根容器可聚焦
if (rootEl && !rootEl.hasAttribute('tabindex')) {
  rootEl.setAttribute('tabindex', '-1');
}
console.log('准备渲染 React App');
const root = ReactDOM.createRoot(rootEl);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
console.log('结束渲染 React App');


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
